module.exports = __webpack_public_path__ + "static/hhinterior-a3663e0ef99e7b3512e42ec5592baa03.jpg";